import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetEmployeesData, GetInputsData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { employeesColumns, inputsColumns } from "../../lib/definitions";
import { deleteEmployeesForm, deleteInputsForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md";
import InputsFilter from "../../ui/searchFilter/inputsFilter";
import EmployeesFilter from "../../ui/searchFilter/emloyeesFilter";
import i18n from "../../lib/i18n";

export default function Employees() {

    const [searchParams] = useSearchParams();
    const [employeesData, setEmployeesData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    // const user = JSON.parse(localStorage.getItem("userData"));
    // const userType = user.type;
    const name = searchParams.get('name');
    const t = i18n.t.bind(i18n); 

    const params = useMemo(() => {
        const tempParams = [];
        if (name) tempParams.push({ name });

        return tempParams;
    }, [ name]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    const handleApi = async () => {
        setIsLoading(true); 
        const employeeData = await GetEmployeesData(currentPage, params);
        setEmployeesData([]);
        setcurrentPage(employeeData.pagination.current_page);
        setlast_page(employeeData.pagination.last_page);
        employeeData.data.map((e) => setEmployeesData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteEmployeesForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            {/* {userType == "employee" && ( */}
                <div className="">
                    <EmployeesFilter values={params} />
                </div>
            {/* )} */}
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <div></div>
                <Button background="#2F7A74" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_employees")}  nav={"/employees/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={inputsColumns}/> : (  
                    <Table columns={employeesColumns} rows={employeesData} openDeleteConfirmation={openDeleteConfirmation} edit="/employees/edit" />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};